import { FaSpinner } from 'react-icons/fa';

type SpinnerProps = {
  width?: number;
  height?: number;
  className?: string;
};

export function Spinner({ width = 24, height = 24, className }: SpinnerProps) {
  return (
    <div className={`flex items-center justify-center ${className || ''}`}>
      <FaSpinner className="animate-spin text-[#3498db]" style={{ width, height }} />
    </div>
  );
}
